export class ClampInputData {
    manufacturerId: string;
    clampId: string;
    pipeSizeId: string;
    //boltDimensionId: string
    boltMaterialId: string;
    clampMaterialId: string;
    //nutDimensionId: string
    sealRingId: string;
    lubricantId: string;

    pipeScheduleId: string;
    hubMaterialId: string;
    sealRingMaterialId: string;

    boltType: number;

    tighteningMethod: number;
    loadLossMethod: number;
    percentageCover: number;
    washerThickness: number;
    misalignmentFactor: number;

    kFactor: number;
    isDataValid: boolean;
    boltMaterialAliasId?: string;
    flangeMaterialAliasId1?: string;
    flangeMaterialAliasId2?: string;
    gasketAliasId?:string;
}
